export const getLocalStorageKey = (cliendId: string): string => {
  // set up the localStorageKey as same as how the rotating token method creates it
  const keyPrefix = '@@auth0spajs@@'
  const defaultScope = 'openid profile email offline_access'
  const defaultAudience = 'default'

  return `${keyPrefix}::${cliendId}::${defaultAudience}::${defaultScope}`
}
